export class PricingCopilotResidentialOptimizedPrice {
	public id: number;
	public term: number;
	public rate: number;
	public bestRate: number;
	public bestDelta: number;
	public productName: string;
	public ptc: number;
	public ptcDelta: number;
	public bestRateOverall: number;
	public bestRateOverallDelta: number;

	constructor(residentialRateMatrixOptimizedPrice?: PricingCopilotResidentialOptimizedPrice) {
		Object.assign(this, residentialRateMatrixOptimizedPrice);
	}
}
